import React from "react";

import { Box, Loader } from "@braintrust/braintrust-ui-components";

export const CommonTeamMembersModalLoader = () => {
  return (
    <Box sx={{ position: "relative", minHeight: "5rem" }}>
      <Loader centered />
    </Box>
  );
};
